<template>
  <div class="tw:border-l tw:border-default-200" :class="isScreenSmall ? 'tw:p-2' : 'tw:p-3'">
    <EdroneLoading :is-loading="value === null" style="height: 100%" unique-id="dd1c604a-7540-4a2d-967a-df707a07f0cc">
      <div class="tw:flex tw:flex-col" :class="isScreenSmall ? 'tw:gap-1' : 'tw:gap-2'">
        <p class="tw:body-2">{{ label }}</p>
        <p :class="[isScreenSmall ? 'tw:body-1--bold' : 'tw:heading-1', 'tw:break-all']">
          {{ formattedValue }}
        </p>
      </div>
    </EdroneLoading>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import EdroneLoading from "edrone-components/EdroneLoading.vue";
import { formatNumberV2, FormatNumberStyle } from "vue-app/utils/functions";
import { useIsScreenSmall } from "vue-app/composables/useIsScreenSmall/useIsScreenSmall.composable";

interface Props {
  label: string;
  value: number | [number, number] | null;
  valueUnit?: FormatNumberStyle;
}

const { label, value, valueUnit } = defineProps<Props>();
const { isScreenSmall } = useIsScreenSmall();

const calculateValue = (value: number, formatStyle?: FormatNumberStyle) => {
  const isPercent = formatStyle === "percent" || valueUnit === "pp";
  return isPercent ? value / 100 : value;
};

const formattedValue = computed(() => {
  if (value === null) return "-";

  if (Array.isArray(value)) {
    const [valueFrom, valueTo] = value;

    const preparedValueFrom = formatNumberV2(calculateValue(valueFrom, valueUnit));
    const preparedValueTo = formatNumberV2(calculateValue(valueTo, valueUnit));

    return `${preparedValueFrom} - ${preparedValueTo}`;
  }

  return formatNumberV2(calculateValue(value, valueUnit), {
    style: valueUnit,
  });
});
</script>
